// extracted by mini-css-extract-plugin
export default {"ChildrenAnimation":"ChildrenAnimation_ChildrenAnimation__M12Y2","blueStatic":"ChildrenAnimation_blueStatic__7SD2Y"};